import request from '@/api/request'
/**
 * @descripttion: 获取下单订单详情
 * @Author: Liuyanfang
 * @Date: 2021-01-06 17:22:28
 * @param {*} params
 * @return {*void}
 */
const getOrderDetail = (params) =>
  request({
    url: '/api/v1/app/trade/order/queryOrderInfo',
    method: 'GET',
    params
  })
// 下单页
const getDetail = (params) =>
  request({
    url: '/api/v1/app/trade/queryOrderInfo',
    method: 'GET',
    params
  })
// 确认订单
const getQueryOrderInfo = (params) =>
  request({
    url: '/api/v1/app/trade/order/queryOrderInfo',
    method: 'GET',
    params
  })
/**
 * @descripttion: 订单确认
 * @Author: Liuyanfang
 * @Date: 2021-01-08 17:28:10
 * @param {*} params
 * @return {*}
 */
const orderConfirm = (params) =>
  request({
    url: '/api/v1/app/trade/confirm',
    method: 'post',
    data: params
  })
/**
 * @descripttion: 下单支付
 * @Author: Liuyanfang
 * @Date: 2021-01-18 10:25:26
 * @param {*} params
 * @return {*}
 */
const orderPay = (params) =>
  request({
    url: '/api/v1/app/trade/pay',
    method: 'post',
    data: params
  })

// 支付保证金
const payDeposit = (params) =>
  request({
    url: '/api/v1/activity/app/auction/payDeposit',
    method: 'post',
    data: params,
    domain: 'activity-app'
  })

// 检查当前用户是否已交保证金
const checkIfPayDeposit = (params) =>
  request({
    url: '/api/v1/activity/app/auction/checkIfPayDeposit',
    method: 'get',
    params: params,
    domain: 'activity-app'
  })

// 检查当前用户是否已交保证金&&经销商查询
const queryPayDepositDealer = (params) =>
  request({
    url: 'api/v1/activity/app/auction/queryPayDepositDealer',
    method: 'get',
    params: params,
    domain: 'activity-app'
  })

// 拍卖出价
const auctionOffer = (params) =>
  request({
    url: '/api/v1/activity/app/auction/auctionOffer',
    method: 'post',
    data: params,
    domain: 'activity-app'
  })

// 获取我的拍卖活动
const getMyAuctionList = (params) =>
  request({
    url: '/api/v1/activity/app/auction/getMyAuctionList',
    method: 'get',
    params: params,
    domain: 'activity-app'
  })

// 查询拍卖出价记录
const getAuctionOfferList = (params) =>
  request({
    url: '/api/v1/activity/app/auction/getAuctionOfferList',
    method: 'get',
    params: params,
    domain: 'activity-app'
  })

// 当前出价
const currentOffer = (params) =>
  request({
    url: '/api/v1/activity/app/auction/currentOffer',
    method: 'get',
    params: params,
    domain: 'activity-app'
  })

/**
 * @descripttion: 订单取消
 * @Author: Liuyanfang
 * @Date: 2021-01-22 11:05:06
 * @param {*} cancelOrder
 * @return {*}
 */
const cancelOrder = (params) =>
  request({
    url: '/api/v1/app/trade/cancel',
    method: 'post',
    data: params
  })
/**
 * @descripttion:  获取支付方式
 * @Author: Liuyanfang
 * @Date: 2021-01-06 15:14:24
 * @param {*} params
 * @return {*}
 */
const getPayType = (params) =>
  request({
    url: '/api/v1/trade/pay',
    method: 'POST',
    data: params
  })
/**
 * @descripttion: 查询用户vin码
 * @Author: Liuyanfang
 * @Date: 2021-01-06 15:49:06
 * @param {*} params
 * @return {*void}
 */
const getVIN = () =>
  request({
    url: '/api/v1/app/trade/getAccountVins',
    // url: '/api/v1/app/trade/listUserVin',
    method: 'GET'
  })
/**
 * @descripttion: 下单更换优惠券,返回订单详情
 * @Author: Liuyanfang
 * @Date: 2021-01-09 15:49:42
 * @param {*} params
 * @return {*}
 */
const getCoupon = (params) =>
  request({
    url: '/api/v1/app/trade/changeCoupon',
    method: 'POST',
    data: params
  })
/**
 * @descripttion: 获取订单状态
 * @Author: Liuyanfang
 * @Date: 2021-02-03 13:10:06
 * @param {*} queryOrderStatus
 * @return {*}
 */

const queryOrderStatus = (params) =>
  request({
    url: '/api/v1/app/trade/queryPayInfo',
    method: 'GET',
    params
  })
/**
 * @descripttion: 计算订单优惠金额
 * @Author: Liuyanfang
 * @Date: 2021-01-12 15:37:51
 * @param {*} params
 * @return {*}
 */
const ComputeOrderDiscount = (params) =>
  request({
    url: '/api/v1/app/trade/computeOrderDiscount',
    method: 'POST',
    params
  })
/**
 * @descripttion: 获取默认收货地址
 * @Author: Liuyanfang
 * @Date: 2021-01-08 10:17:08
 * @param {*}
 * @return {*}
 */
const findDefaultAddrByUserId = () =>
  request({
    url: '/api/v1/cuz/address/default',
    method: 'get',
    domain: 'mallUser'
  })
/**
 * @descripttion: 设置默认收货地址
 * @Author: Liuyanfang
 * @Date: 2021-01-09 11:08:17
 * @param {*} params
 * @return {*}
 */
const setDefaultAddress = (params) =>
  request({
    url: '/api/v1/cuz/address/default',
    method: 'POST',
    params,
    domain: 'mallUser'
  })
/**
 * @descripttion: 获得当前用户收货地址列表
 * @Author: Liuyanfang
 * @Date: 2021-01-09 10:48:51
 * @param {*} params
 * @return {*}
 */
const getAddressList = () =>
  request({
    url: '/api/v1/cuz/address/list',
    method: 'GET',
    domain: 'mallUser'
  })
/**
 * @descripttion: 新增收货地址
 * @Author: Liuyanfang
 * @Date: 2021-01-08 10:19:39
 * @param {*} data
 * @return {*}
 */
const addAddress = (params) =>
  request({
    url: '/api/v1/cuz/address/create',
    method: 'POST',
    data: params,
    domain: 'mallUser'
  })
/**
 * @descripttion: 修改地址
 * @Author: Liuyanfang
 * @Date: 2021-01-09 13:14:36
 * @param {*} params
 * @return {*}
 */
const updateAddress = (params) =>
  request({
    url: '/api/v1/cuz/address/update',
    method: 'POST',
    data: params,
    domain: 'mallUser'
  })
/**
 * @descripttion: 获取用户信息
 * @Author: Liuyanfang
 * @Date: 2021-01-14 14:09:47
 * @param {*}
 * @return {*}
 */

const getUserInfo = () => {
  return request({
    url: '/api/v1/cuz/user/info',
    method: 'GET',
    domain: 'mallUser'
  })
}
/**
 * @descripttion: 查询物流详细信息
 * @Author: cuiyuan
 * @Date: 2021-01-14 14:09:47
 * @param {void}
 * @return {void}
 */
const getLogistics = (params) => {
  return request({
    url: '/api/v1/app/trade/order/queryExpressByItemId',
    method: 'GET',
    params
  })
}
/**
 * @param {*} params 活动id
 * @returns {void}
 */
const getCurrentOfferAndOfferList = (params) => {
  return request({
    url: '/api/v1/activity/app/auction/getCurrentOfferAndOfferList',
    method: 'GET',
    params,
    domain: 'activity-app'
  })
}
export default {
  getOrderDetail,
  getDetail,
  getQueryOrderInfo,
  orderConfirm,
  orderPay,
  payDeposit,
  checkIfPayDeposit,
  auctionOffer,
  getMyAuctionList,
  getAuctionOfferList,
  getCurrentOfferAndOfferList,
  currentOffer,
  cancelOrder,
  getPayType,
  getVIN,
  getCoupon,
  queryOrderStatus,
  ComputeOrderDiscount,
  findDefaultAddrByUserId,
  setDefaultAddress,
  addAddress,
  updateAddress,
  getAddressList,
  getUserInfo,
  getLogistics,
  queryPayDepositDealer
}
